import React, { Component } from "react";
import "./AnchorLink.scss";
class AnchorLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opacity: "0",
    };
    this.smoothScroll = this.smoothScroll.bind(this);
  }
  componentDidMount() {
    require("smoothscroll-polyfill").polyfill();
    if (this.props.opactityid) {
      if (typeof window !== "undefined") {
        var el = document.getElementById(this.props.opactityid);
        window.onscroll = () => {
          let height = el.offsetTop;
          let currentScrollPos = window.pageYOffset;
          if (currentScrollPos > height + 200) {
            this.setState({ opacity: "1" });
          } else {
            this.setState({ opacity: "0" });
          }
        };
      }
    }
  }
  smoothScroll(e) {
    e.preventDefault();
    let offset = () => 0;
    if (typeof this.props.offset !== "undefined") {
      if (
        !!(
          this.props.offset &&
          this.props.offset.constructor &&
          this.props.offset.apply
        )
      ) {
        offset = this.props.offset;
      } else {
        offset = () => parseInt(this.props.offset);
      }
    }
    const id = e.currentTarget.getAttribute("href").slice(1);
    const $anchor = document.getElementById(id);
    const offsetTop = $anchor.getBoundingClientRect().top + window.pageYOffset;
    window.scroll({
      top: offsetTop - offset(),
      behavior: "smooth",
    });
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
  render() {
    const { offset, ...rest } = this.props;
    return (
      <a
        {...rest}
        onClick={this.smoothScroll}
        style={{ opacity: `${this.state.opacity}` }}
      >
        {this.props.children}
      </a>
    );
  }
}

export default AnchorLink;
